import React, { useContext, useEffect, useRef, useState } from "react";
import Badge from "../../../../CommonComponents/Badge";
import useAxiosPrivate from "../../../../../Hooks/useAxiosPrivate";
import useCommonFunctionHooks from "../../../../../Hooks/useCommonFunctionHooks";
import AlertContext from "../../../../../context/AlertContext";
import Textarea from "../../../../CommonComponents/Textarea";
import { getDataFromStorage } from "../../../../../util";
import Checkbox from "../../../../CommonComponents/Checkbox";
import Slide from "@mui/material/Slide";
import Toast from "../../../../CommonComponents/Toast";
import { nanoid } from "nanoid";
import useS3FileManagement from "../../../../../Hooks/useS3FileManagement";
import Button from "../../../../Button";
import IconButton from "../../../../CommonComponents/IconButton";
import FeaturedIcon from "../../../../CommonComponents/FeaturedIcon";

const Feedback = ({
  feedback,
  setFeedBacks,
  from,
  toastMessage,
  setToastMessage,
  toastOpen,
  setToastOpen,
  handleClose,
  clearAllState,
  SlideTransition,
}) => {
  const fileInputRef = useRef(null);
  const [editLoading, setEditLoading] = useState(false);
  const [editFeedback, setEditFeedback] = useState(false);
  const [editFeedbackMessage, setEditFeedbackMessage] = useState("");
  const axios = useAxiosPrivate();
  const Alert = useContext(AlertContext);
  const useCommonFunctionHks = useCommonFunctionHooks();
  const [selectedCheckboxValue, setSelectedCheckboxValue] = useState({
    student: false,
    parent: false,
  });
  const isOwner = getDataFromStorage("learnerid") == feedback.created_by;
  const [isAttachmentChange, setIsAttachmentChange] = useState(false);
  const [currentAttachment, setCurrentAttachment] = useState([]);
  const [editAttachmentFiles, setEditAttachmentFiles] = useState([]);
  const [newAttachedFiles, setNewAttachedFiles] = useState([]);
  const { onUploadS3Object, getPreSignedUrl } = useS3FileManagement();
  const { vertical, horizontal, open, Transition } = toastOpen;
  const getVisibleStatus = () => {
    if (selectedCheckboxValue.student && selectedCheckboxValue.parent) {
      return 3;
    } else if (selectedCheckboxValue.student) {
      return 1;
    } else if (selectedCheckboxValue.parent) {
      return 2;
    } else {
      return 0;
    }
  };

  const deleteFeedback = async (id) => {
    try {
      const response = await axios.delete(
        `/node/admin/studentremarks/${id}`,
        useCommonFunctionHks.getHeaderDetailsForAxios()
      );
      if (response.data.resultCode !== 1000) {
        setToastMessage((prev) => ({
          message: response.data?.msg,
          icon: (
            <svg
              width="56"
              height="56"
              fill="none"
              viewBox="0 0 56 56"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="4"
                y="4"
                width="48"
                height="48"
                rx="24"
                fill={"#FEF0C7"}
              />
              <rect
                x="4"
                y="4"
                rx="24"
                width="48"
                height="48"
                stroke-width="8"
                stroke="#FFFBFA"
              />
              <path
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M27.9998 24.0012V28.0012M27.9998 32.0012H28.0098M26.2898 18.8612L17.8198 33.0012C17.6451 33.3036 17.5527 33.6465 17.5518 33.9957C17.5508 34.3449 17.6413 34.6883 17.8142 34.9917C17.9871 35.2951 18.2365 35.5479 18.5375 35.725C18.8385 35.9021 19.1806 35.9973 19.5298 36.0012H36.4698C36.819 35.9973 37.1611 35.9021 37.4621 35.725C37.7631 35.5479 38.0124 35.2951 38.1854 34.9917C38.3583 34.6883 38.4488 34.3449 38.4478 33.9957C38.4468 33.6465 38.3544 33.3036 38.1798 33.0012L29.7098 18.8612C29.5315 18.5673 29.2805 18.3243 28.981 18.1557C28.6814 17.987 28.3435 17.8984 27.9998 17.8984C27.656 17.8984 27.3181 17.987 27.0186 18.1557C26.7191 18.3243 26.468 18.5673 26.2898 18.8612Z"
                stroke={"#D92D20"}
              />
            </svg>
          ),
        }));

        setToastOpen({
          vertical: "top",
          horizontal: "right",
          open: true,
          Transition: SlideTransition,
        });
        throw new Error(
          "Something went wrong while deleting feedback of the student"
        );
      }

      setToastMessage((prev) => ({
        message: "Feedback deleted successfully",
        icon: (
          <svg
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="3" y="3" width="40" height="40" rx="20" fill="#D1FADF" />
            <rect
              x="3"
              y="3"
              width="40"
              height="40"
              rx="20"
              stroke="#ECFDF3"
              stroke-width="6"
            />
            <g clip-path="url(#clip0_1393_14704)">
              <path
                d="M20.5003 23L22.167 24.6667L25.917 20.9167M19.1118 16.1822C19.7817 16.1288 20.4176 15.8654 20.929 15.4295C22.1226 14.4124 23.8781 14.4124 25.0716 15.4295C25.5831 15.8654 26.219 16.1288 26.8889 16.1822C28.452 16.307 29.6933 17.5483 29.8181 19.1115C29.8715 19.7813 30.1349 20.4173 30.5708 20.9287C31.5879 22.1223 31.5879 23.8777 30.5708 25.0713C30.1349 25.5827 29.8715 26.2187 29.8181 26.8885C29.6933 28.4517 28.452 29.693 26.8889 29.8178C26.219 29.8712 25.5831 30.1346 25.0716 30.5705C23.8781 31.5876 22.1226 31.5876 20.929 30.5705C20.4176 30.1346 19.7817 29.8712 19.1118 29.8178C17.5486 29.693 16.3073 28.4517 16.1826 26.8885C16.1291 26.2187 15.8657 25.5827 15.4298 25.0713C14.4127 23.8777 14.4127 22.1223 15.4298 20.9287C15.8657 20.4173 16.1291 19.7813 16.1826 19.1115C16.3073 17.5483 17.5486 16.307 19.1118 16.1822Z"
                stroke="#039855"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_1393_14704">
                <rect
                  width="20"
                  height="20"
                  fill="white"
                  transform="translate(13 13)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
      }));
      setToastOpen({
        vertical: "top",
        horizontal: "right",
        open: true,
        Transition: SlideTransition,
      });
      // feedBacks.filter((feedback)=>feedback.id!==id);
      setFeedBacks((prev) => prev.filter((fb) => fb.id !== id));
      // clearAllState();
    } catch (error) {
      console.log("error in delete feedback:", error);
    }
  };

  const handleAddAttachments = (event) => {
    let commentedDate = String(new Date());
    let newAttachment = [...newAttachedFiles];
    let files = Array.from(event.target.files);

    for (let i = 0; i < files.length; i++) {
      let attachment = { id: nanoid(), file: files[i], date: commentedDate };
      newAttachment.push(attachment);
    }
    setNewAttachedFiles(newAttachment);
    setIsAttachmentChange(true);
    event.target.value = "";
  };
  const handleDeleteAttachments = (attachmentId) => {
    setNewAttachedFiles((prevAttachment) =>
      prevAttachment.filter((attachment) => attachment.id !== attachmentId)
    );
  };
  const editFeedbackFunction = async (id) => {
    try {

      let time = new Date();
      let attachment = newAttachedFiles.map((at) => {
        const original = at.file.name;
        const dotIndex = original.lastIndexOf(".");
        const base = original.substring(0, dotIndex);
        const ext = original.substring(dotIndex + 1);

        return {
          name: `${base}_${time}.${ext}`,
        };
      });

      setEditLoading(true);
      const response = await axios.put(
        `/node/admin/studentremarks/${id}`,
        {
          feedback: editFeedbackMessage,
          visible_to: getVisibleStatus(),
          wholeAttachments: isAttachmentChange
            ? [editAttachmentFiles, ...attachment]
            : [],
        },
        useCommonFunctionHks.getHeaderDetailsForAxios()
      );
      if (response.data.resultCode !== 1000) {
        setToastMessage((prev) => ({
          message: response.data?.msg ?? response.data.error,
          icon: (
            <svg
              width="56"
              height="56"
              fill="none"
              viewBox="0 0 56 56"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="4"
                y="4"
                width="48"
                height="48"
                rx="24"
                fill={"#FEF0C7"}
              />
              <rect
                x="4"
                y="4"
                rx="24"
                width="48"
                height="48"
                stroke-width="8"
                stroke="#FFFBFA"
              />
              <path
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M27.9998 24.0012V28.0012M27.9998 32.0012H28.0098M26.2898 18.8612L17.8198 33.0012C17.6451 33.3036 17.5527 33.6465 17.5518 33.9957C17.5508 34.3449 17.6413 34.6883 17.8142 34.9917C17.9871 35.2951 18.2365 35.5479 18.5375 35.725C18.8385 35.9021 19.1806 35.9973 19.5298 36.0012H36.4698C36.819 35.9973 37.1611 35.9021 37.4621 35.725C37.7631 35.5479 38.0124 35.2951 38.1854 34.9917C38.3583 34.6883 38.4488 34.3449 38.4478 33.9957C38.4468 33.6465 38.3544 33.3036 38.1798 33.0012L29.7098 18.8612C29.5315 18.5673 29.2805 18.3243 28.981 18.1557C28.6814 17.987 28.3435 17.8984 27.9998 17.8984C27.656 17.8984 27.3181 17.987 27.0186 18.1557C26.7191 18.3243 26.468 18.5673 26.2898 18.8612Z"
                stroke={"#D92D20"}
              />
            </svg>
          ),
        }));

        setToastOpen({
          vertical: "top",
          horizontal: "right",
          open: true,
          Transition: SlideTransition,
        });
        throw new Error(
          "Something went wrong while updating feedback of the student"
        );
      }

      //upload attachments if any to s3
      try {
        for (let i = 0; i < newAttachedFiles.length; i++) {
          let res = await onUploadS3Object(
            response?.data?.keys[i],
            newAttachedFiles[i].file,
            newAttachedFiles[i].file.type.split("/")[1],
            undefined,
            "PUT"
          );
        }
        if (newAttachedFiles.length >= 1) {
          clearAllState();
        }
      } catch (error) {
        throw new Error("Failed to upload in S3");
      }

      setToastMessage((prev) => ({
        message: response.data?.msg,
        icon: (
          <svg
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="3" y="3" width="40" height="40" rx="20" fill="#D1FADF" />
            <rect
              x="3"
              y="3"
              width="40"
              height="40"
              rx="20"
              stroke="#ECFDF3"
              stroke-width="6"
            />
            <g clip-path="url(#clip0_1393_14704)">
              <path
                d="M20.5003 23L22.167 24.6667L25.917 20.9167M19.1118 16.1822C19.7817 16.1288 20.4176 15.8654 20.929 15.4295C22.1226 14.4124 23.8781 14.4124 25.0716 15.4295C25.5831 15.8654 26.219 16.1288 26.8889 16.1822C28.452 16.307 29.6933 17.5483 29.8181 19.1115C29.8715 19.7813 30.1349 20.4173 30.5708 20.9287C31.5879 22.1223 31.5879 23.8777 30.5708 25.0713C30.1349 25.5827 29.8715 26.2187 29.8181 26.8885C29.6933 28.4517 28.452 29.693 26.8889 29.8178C26.219 29.8712 25.5831 30.1346 25.0716 30.5705C23.8781 31.5876 22.1226 31.5876 20.929 30.5705C20.4176 30.1346 19.7817 29.8712 19.1118 29.8178C17.5486 29.693 16.3073 28.4517 16.1826 26.8885C16.1291 26.2187 15.8657 25.5827 15.4298 25.0713C14.4127 23.8777 14.4127 22.1223 15.4298 20.9287C15.8657 20.4173 16.1291 19.7813 16.1826 19.1115C16.3073 17.5483 17.5486 16.307 19.1118 16.1822Z"
                stroke="#039855"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_1393_14704">
                <rect
                  width="20"
                  height="20"
                  fill="white"
                  transform="translate(13 13)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
      }));
      setToastOpen({
        vertical: "top",
        horizontal: "right",
        open: true,
        Transition: SlideTransition,
      });
      // clearAllState();
      setFeedBacks((prev) =>
        prev.map((p) =>
          p.id === id
            ? {
                ...p,
                feedback: editFeedbackMessage,
                visible_to: getVisibleStatus(),
                ...(currentAttachment.file_link && { file_link: currentAttachment.file_link })
              }
            : p
        )
      );
      setEditLoading(false);
    } catch (error) {
      setEditLoading(false);
      console.log("error in update feedback:", error);
    }
  };

  const loadEditValues = (feedback) => {
    setSelectedCheckboxValue({
      student: feedback.visible_to === 1 || feedback.visible_to === 3,
      parent: feedback.visible_to === 2 || feedback.visible_to === 3,
    });
  };

  const normalizeLetters = (name) => {
    if (!name) return ""; // handle null/undefined/empty
    const trimmed = name.trim();
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
  };

  const removeAttachedFile = (feedback, fileName, type, index) => {
    const encodedName = encodeURIComponent(fileName);

    const updatedFeedback = {
      ...feedback,
      file_url: feedback.file_url
        .split(",")
        .filter((file) => !file.includes(fileName))
        .join(","),

      file_name: feedback.file_name.filter((fname) => fname !== fileName),
      file_link: feedback.file_link
        ? {
            ...feedback.file_link,
            url: feedback.file_link.url.filter((_, i) => i !== index),
          }
        : feedback.file_link,
    };
    let fileChangedAttachment = {
      key: feedback.file_url
        .split(",")
        .filter((file) => file.includes(fileName))
        .join(","),

      file_name: feedback.file_name.filter((fname) => fname === fileName),
    };

    setEditAttachmentFiles(fileChangedAttachment);
    setCurrentAttachment(updatedFeedback);
    setIsAttachmentChange(true);
  };

  return (
    <div className="student-feedback-container">
      {!editFeedback && (
        <>
          <div className="student-feedback-msg">
            <div>{feedback?.feedback}</div>
            <div className="student-feedback-attachment">
              {feedback?.file_link &&
                feedback?.file_link?.url?.map((url, index) => {
                  return (
                    <div
                      className="student-feedback-attachment-container"
                      onClick={() => window.open(url, "_blank")}
                    >
                      <div className="student-feedback-file-attachment-icon">
                        <FeaturedIcon
                          icon={
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_1244_3355)">
                                <path
                                  d="M10.7201 5.52502L6.12514 10.12C5.56222 10.6829 4.79874 10.9992 4.00265 10.9992C3.20655 10.9992 2.44307 10.6829 1.88014 10.12C1.31722 9.5571 1.00098 8.79361 1.00098 7.99752C1.00098 7.20143 1.31722 6.43794 1.88014 5.87502L6.47514 1.28002C6.85043 0.904739 7.35942 0.693909 7.89014 0.693909C8.42087 0.693909 8.92986 0.904739 9.30515 1.28002C9.68043 1.6553 9.89126 2.16429 9.89126 2.69502C9.89126 3.22575 9.68043 3.73474 9.30515 4.11002L4.70514 8.70502C4.5175 8.89266 4.26301 8.99808 3.99764 8.99808C3.73228 8.99808 3.47779 8.89266 3.29014 8.70502C3.1025 8.51738 2.99709 8.26288 2.99709 7.99752C2.99709 7.73216 3.1025 7.47766 3.29014 7.29002L7.53514 3.05002"
                                  stroke="#344054"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1244_3355">
                                  <rect width="12" height="12" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          }
                          size="xs"
                          color="primary"
                          theme="modern"
                        />

                        <div
                          style={{
                            fontFamily: "inter",
                            fontWeight: "500",
                            fontSize: "10.77px",
                            leadingTrim: "NONE",
                            lineHeight: "15.38px",
                            letterSpacing: "0%",
                            color: "#344054",
                          }}
                        >{`${feedback?.file_name[index].slice(0, 17)}...`}</div>
                        {/* </div> */}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="student-feedback-second-section">
            <div className="student-feedback-info-container">
              <div className="student-feedback-info-date">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.6667 1.33331V3.99998M5.33333 1.33331V3.99998M2 6.66665H14M3.33333 2.66665H12.6667C13.403 2.66665 14 3.2636 14 3.99998V13.3333C14 14.0697 13.403 14.6666 12.6667 14.6666H3.33333C2.59695 14.6666 2 14.0697 2 13.3333V3.99998C2 3.2636 2.59695 2.66665 3.33333 2.66665Z"
                    stroke="#667085"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <div className="date">{feedback.updated_date}</div>
              </div>
              <div className="student-feedback-info-createdby">
                {feedback?.name && from !== "reportfeedback" && (
                  <Badge
                    icon={{
                      icon: (
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_1574_3453)">
                            <path
                              d="M6 10.5L5.94997 10.425C5.60265 9.90398 5.42899 9.64349 5.19955 9.45491C4.99643 9.28796 4.76238 9.1627 4.5108 9.0863C4.22663 9 3.91355 9 3.28741 9H2.6C2.03995 9 1.75992 9 1.54601 8.89101C1.35785 8.79513 1.20487 8.64215 1.10899 8.45399C1 8.24008 1 7.96005 1 7.4V3.1C1 2.53995 1 2.25992 1.10899 2.04601C1.20487 1.85785 1.35785 1.70487 1.54601 1.60899C1.75992 1.5 2.03995 1.5 2.6 1.5H2.8C3.9201 1.5 4.48016 1.5 4.90798 1.71799C5.28431 1.90973 5.59027 2.21569 5.78201 2.59202C6 3.01984 6 3.5799 6 4.7M6 10.5V4.7M6 10.5L6.05003 10.425C6.39735 9.90398 6.57101 9.64349 6.80045 9.45491C7.00357 9.28796 7.23762 9.1627 7.4892 9.0863C7.77337 9 8.08645 9 8.71259 9H9.4C9.96005 9 10.2401 9 10.454 8.89101C10.6422 8.79513 10.7951 8.64215 10.891 8.45399C11 8.24008 11 7.96005 11 7.4V3.1C11 2.53995 11 2.25992 10.891 2.04601C10.7951 1.85785 10.6422 1.70487 10.454 1.60899C10.2401 1.5 9.96005 1.5 9.4 1.5H9.2C8.07989 1.5 7.51984 1.5 7.09202 1.71799C6.71569 1.90973 6.40973 2.21569 6.21799 2.59202C6 3.01984 6 3.5799 6 4.7"
                              stroke="#667085"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1574_3453">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      ),
                      position: "start",
                      isOnly: false,
                    }}
                    size="sm"
                    label={feedback.name}
                  />
                )}
                <Badge
                  icon={{
                    icon: (
                      <svg
                        width="12"
                        height="11"
                        viewBox="0 0 12 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.25 7H3.5C2.80222 7 2.45333 7 2.16943 7.08612C1.53023 7.28002 1.03002 7.78023 0.83612 8.41943C0.75 8.70333 0.75 9.05222 0.75 9.75M7 3C7 4.24264 5.99264 5.25 4.75 5.25C3.50736 5.25 2.5 4.24264 2.5 3C2.5 1.75736 3.50736 0.75 4.75 0.75C5.99264 0.75 7 1.75736 7 3ZM5.25 9.75L6.80068 9.30695C6.87493 9.28573 6.91206 9.27512 6.94669 9.25922C6.97744 9.24511 7.00668 9.2279 7.03395 9.20788C7.06467 9.18533 7.09197 9.15803 7.14658 9.10342L10.375 5.87502C10.7202 5.52983 10.7202 4.97017 10.375 4.62499C10.0298 4.27981 9.47019 4.27982 9.12501 4.625L5.89658 7.85342C5.84197 7.90803 5.81467 7.93533 5.79212 7.96605C5.7721 7.99332 5.75489 8.02256 5.74078 8.05331C5.72487 8.08794 5.71427 8.12507 5.69305 8.19933L5.25 9.75Z"
                          stroke="#667085"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    ),
                    position: "start",
                    isOnly: false,
                  }}
                  size="sm"
                  label={normalizeLetters(feedback.creator_name)}
                />
              </div>
            </div>
            {isOwner && !editFeedback && (
              <div className="student-feedback-hovering-option">
                <IconButton
                  size="sm"
                  hierarchy="secondaryGrey"
                  destructive={true}
                  onClick={() => {
                    deleteFeedback(feedback.id);
                  }}
                >
                  <svg
                    width="17"
                    height="19"
                    viewBox="0 0 17 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.834961 4.16836H2.50163M2.50163 4.16836H15.835M2.50163 4.16836V15.835C2.50163 16.277 2.67722 16.701 2.98978 17.0135C3.30234 17.3261 3.72627 17.5017 4.16829 17.5017H12.5016C12.9437 17.5017 13.3676 17.3261 13.6801 17.0135C13.9927 16.701 14.1683 16.277 14.1683 15.835V4.16836H2.50163ZM5.00163 4.16836V2.50169C5.00163 2.05966 5.17722 1.63574 5.48978 1.32318C5.80234 1.01062 6.22627 0.835022 6.66829 0.835022H10.0016C10.4437 0.835022 10.8676 1.01062 11.1801 1.32318C11.4927 1.63574 11.6683 2.05966 11.6683 2.50169V4.16836M6.66829 8.33502V13.335M10.0016 8.33502V13.335"
                      stroke="#B42318"
                      stroke-width="1.67"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </IconButton>
                <IconButton
                  size="sm"
                  hierarchy="secondaryGrey"
                  destructive={false}
                  onClick={() => {
                    setEditFeedbackMessage(feedback.feedback);
                    loadEditValues(feedback);
                    setEditFeedback(true);
                    setCurrentAttachment(feedback);
                  }}
                >
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.33496 2.60279H2.50163C2.0596 2.60279 1.63568 2.77838 1.32312 3.09094C1.01056 3.4035 0.834961 3.82743 0.834961 4.26946V15.9361C0.834961 16.3781 1.01056 16.8021 1.32312 17.1146C1.63568 17.4272 2.0596 17.6028 2.50163 17.6028H14.1683C14.6103 17.6028 15.0342 17.4272 15.3468 17.1146C15.6594 16.8021 15.835 16.3781 15.835 15.9361V10.1028M14.585 1.35279C14.9165 1.02127 15.3661 0.835022 15.835 0.835022C16.3038 0.835022 16.7534 1.02127 17.085 1.35279C17.4165 1.68431 17.6027 2.13395 17.6027 2.60279C17.6027 3.07163 17.4165 3.52127 17.085 3.85279L9.16829 11.7695L5.83496 12.6028L6.66829 9.26946L14.585 1.35279Z"
                      stroke="#344054"
                      stroke-width="1.67"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </IconButton>
              </div>
            )}
          </div>
        </>
      )}

      {editFeedback && (
        <div className="student-feedback-edit">
          <div className="student-feedback-msg">
            {/* <div>{feedback.feedback}</div> */}
            <Textarea
              placeholder=""
              autofocus={true}
              value={editFeedbackMessage}
              onChange={(e) => setEditFeedbackMessage(e.target.value)}
              className="editMsg"
            />
            <input
              multiple
              type="file"
              accept="image/*"
              onChange={handleAddAttachments}
              ref={fileInputRef}
            />
            {(!currentAttachment.hasOwnProperty("file_link") ||
              currentAttachment?.file_link?.url.length === 0) &&
              newAttachedFiles &&
              newAttachedFiles.length === 0 && (
                <Button
                  size="sm"
                  onClick={(event) => {
                    event.preventDefault();
                    fileInputRef.current.click();
                  }}
                  hierarchy={{
                    type: "tertiaryGrey",
                    buttonText: "Add Attachment",
                  }}
                  icon={{
                    type: "leading",
                    icon: (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5M14.1667 6.66667L10 2.5M10 2.5L5.83333 6.66667M10 2.5V12.5"
                          stroke="#667085"
                          stroke-width="1.67"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    ),
                  }}
                />
              )}
            {((currentAttachment.hasOwnProperty("file_link") &&
              currentAttachment?.file_link?.url?.length >= 1) ||
              newAttachedFiles?.length >= 1) && (
              <div className="student-feedback-attachment">
                {currentAttachment?.file_link &&
                  currentAttachment?.file_link?.url.map((url, index) => {
                    return (
                      <div className="student-feedback-attachment-container">
                        <div className="student-feedback-file-attachment-icon">
                          <FeaturedIcon
                            icon={
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_1244_3355)">
                                  <path
                                    d="M10.7201 5.52502L6.12514 10.12C5.56222 10.6829 4.79874 10.9992 4.00265 10.9992C3.20655 10.9992 2.44307 10.6829 1.88014 10.12C1.31722 9.5571 1.00098 8.79361 1.00098 7.99752C1.00098 7.20143 1.31722 6.43794 1.88014 5.87502L6.47514 1.28002C6.85043 0.904739 7.35942 0.693909 7.89014 0.693909C8.42087 0.693909 8.92986 0.904739 9.30515 1.28002C9.68043 1.6553 9.89126 2.16429 9.89126 2.69502C9.89126 3.22575 9.68043 3.73474 9.30515 4.11002L4.70514 8.70502C4.5175 8.89266 4.26301 8.99808 3.99764 8.99808C3.73228 8.99808 3.47779 8.89266 3.29014 8.70502C3.1025 8.51738 2.99709 8.26288 2.99709 7.99752C2.99709 7.73216 3.1025 7.47766 3.29014 7.29002L7.53514 3.05002"
                                    stroke="#344054"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1244_3355">
                                    <rect width="12" height="12" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            }
                            size="xs"
                            color="primary"
                            theme="modern"
                          />
                          <div
                            style={{
                              fontFamily: "inter",
                              fontWeight: "500",
                              fontSize: "10.77px",
                              leadingTrim: "NONE",
                              lineHeight: "15.38px",
                              letterSpacing: "0%",
                              color: "#344054",
                            }}
                          >{`${currentAttachment?.file_name[index]?.slice(
                            0,
                            12
                          )}...`}</div>
                          {/* </div> */}
                        </div>
                        <IconButton
                          size="sm"
                          hierarchy="tertiaryGrey"
                          destructive={true}
                          onClick={() => {
                            removeAttachedFile(
                              currentAttachment,
                              currentAttachment?.file_name[index],
                              "old",
                              index
                            );
                          }}
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1974_2176)">
                              <path
                                d="M1.6665 3.33331H2.77762M2.77762 3.33331H11.6665M2.77762 3.33331V11.1111C2.77762 11.4058 2.89468 11.6884 3.10305 11.8968C3.31143 12.1051 3.59404 12.2222 3.88873 12.2222H9.44428C9.73897 12.2222 10.0216 12.1051 10.23 11.8968C10.4383 11.6884 10.5554 11.4058 10.5554 11.1111V3.33331H2.77762ZM4.44428 3.33331V2.2222C4.44428 1.92751 4.56135 1.64489 4.76972 1.43652C4.97809 1.22815 5.26071 1.11108 5.55539 1.11108H7.77762C8.0723 1.11108 8.35492 1.22815 8.56329 1.43652C8.77166 1.64489 8.88873 1.92751 8.88873 2.2222V3.33331M5.55539 6.11108V9.44442M7.77762 6.11108V9.44442"
                                stroke="#B42318"
                                stroke-width="1.11333"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1974_2176">
                                <rect
                                  width="13.3333"
                                  height="13.3333"
                                  fill="white"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </IconButton>
                      </div>
                    );
                  })}
                {newAttachedFiles &&
                  newAttachedFiles?.map((attachment) => (
                    <div className="student-feedback-attachment-container">
                      <div className="student-feedback-file-attachment-icon">
                        <FeaturedIcon
                          icon={
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_1244_3355)">
                                <path
                                  d="M10.7201 5.52502L6.12514 10.12C5.56222 10.6829 4.79874 10.9992 4.00265 10.9992C3.20655 10.9992 2.44307 10.6829 1.88014 10.12C1.31722 9.5571 1.00098 8.79361 1.00098 7.99752C1.00098 7.20143 1.31722 6.43794 1.88014 5.87502L6.47514 1.28002C6.85043 0.904739 7.35942 0.693909 7.89014 0.693909C8.42087 0.693909 8.92986 0.904739 9.30515 1.28002C9.68043 1.6553 9.89126 2.16429 9.89126 2.69502C9.89126 3.22575 9.68043 3.73474 9.30515 4.11002L4.70514 8.70502C4.5175 8.89266 4.26301 8.99808 3.99764 8.99808C3.73228 8.99808 3.47779 8.89266 3.29014 8.70502C3.1025 8.51738 2.99709 8.26288 2.99709 7.99752C2.99709 7.73216 3.1025 7.47766 3.29014 7.29002L7.53514 3.05002"
                                  stroke="#344054"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1244_3355">
                                  <rect width="12" height="12" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          }
                          size="xs"
                          color="primary"
                          theme="modern"
                        />
                        <div
                          style={{
                            fontFamily: "inter",
                            fontWeight: "500",
                            fontSize: "10.77px",
                            leadingTrim: "NONE",
                            lineHeight: "15.38px",
                            letterSpacing: "0%",
                            color: "#344054",
                          }}
                        >{`${attachment.file.name.slice(0, 12)}...`}</div>
                      </div>
                      <IconButton
                        onClick={() => {
                          handleDeleteAttachments(attachment.id);
                        }}
                        hierarchy="tertiaryGrey"
                        size="sm"
                        destructive={true}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_1961_1203)">
                            <path
                              d="M1.6665 3.33331H2.77762M2.77762 3.33331H11.6665M2.77762 3.33331V11.1111C2.77762 11.4058 2.89468 11.6884 3.10305 11.8968C3.31143 12.1051 3.59404 12.2222 3.88873 12.2222H9.44428C9.73897 12.2222 10.0216 12.1051 10.23 11.8968C10.4383 11.6884 10.5554 11.4058 10.5554 11.1111V3.33331H2.77762ZM4.44428 3.33331V2.2222C4.44428 1.92751 4.56135 1.64489 4.76972 1.43652C4.97809 1.22815 5.26071 1.11108 5.55539 1.11108H7.77762C8.0723 1.11108 8.35492 1.22815 8.56329 1.43652C8.77166 1.64489 8.88873 1.92751 8.88873 2.2222V3.33331M5.55539 6.11108V9.44442M7.77762 6.11108V9.44442"
                              stroke="#B42318"
                              stroke-width="1.11333"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1961_1203">
                              <rect
                                width="13.3333"
                                height="13.3333"
                                fill="white"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </IconButton>
                    </div>
                  ))}

                <IconButton
                  size="sm"
                  onClick={() => fileInputRef.current.click()}
                  hierarchy="secondaryGrey"
                  destructive={false}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5M14.1667 6.66667L10 2.5M10 2.5L5.83333 6.66667M10 2.5V12.5"
                      stroke="#344054"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </IconButton>
              </div>
            )}
            <div className="students-remark-feedback-edit-visible-status">
              <div className="students-remark-feedback-visible-header">
                Feedback visible for:
              </div>
              <div className="students-remark-feedback-visible-option">
                <Checkbox
                  text="Student"
                  checked={selectedCheckboxValue.student}
                  onChange={(checked) =>
                    setSelectedCheckboxValue((prev) => ({
                      ...prev,
                      student: checked,
                    }))
                  }
                />
                <Checkbox
                  text="Parent"
                  checked={selectedCheckboxValue.parent}
                  onChange={(checked) =>
                    setSelectedCheckboxValue((prev) => ({
                      ...prev,
                      parent: checked,
                    }))
                  }
                />
              </div>
            </div>
          </div>
          <div className="student-feedback-second-section">
            <div className="student-feedback-info-container">
              <div className="student-feedback-info-date">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.6667 1.33331V3.99998M5.33333 1.33331V3.99998M2 6.66665H14M3.33333 2.66665H12.6667C13.403 2.66665 14 3.2636 14 3.99998V13.3333C14 14.0697 13.403 14.6666 12.6667 14.6666H3.33333C2.59695 14.6666 2 14.0697 2 13.3333V3.99998C2 3.2636 2.59695 2.66665 3.33333 2.66665Z"
                    stroke="#667085"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <div className="date">{feedback.updated_date}</div>
              </div>
              <div className="student-feedback-info-createdby">
                {feedback?.name && from !== "reportfeedback" && (
                  <Badge
                    icon={{
                      icon: (
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_1574_3453)">
                            <path
                              d="M6 10.5L5.94997 10.425C5.60265 9.90398 5.42899 9.64349 5.19955 9.45491C4.99643 9.28796 4.76238 9.1627 4.5108 9.0863C4.22663 9 3.91355 9 3.28741 9H2.6C2.03995 9 1.75992 9 1.54601 8.89101C1.35785 8.79513 1.20487 8.64215 1.10899 8.45399C1 8.24008 1 7.96005 1 7.4V3.1C1 2.53995 1 2.25992 1.10899 2.04601C1.20487 1.85785 1.35785 1.70487 1.54601 1.60899C1.75992 1.5 2.03995 1.5 2.6 1.5H2.8C3.9201 1.5 4.48016 1.5 4.90798 1.71799C5.28431 1.90973 5.59027 2.21569 5.78201 2.59202C6 3.01984 6 3.5799 6 4.7M6 10.5V4.7M6 10.5L6.05003 10.425C6.39735 9.90398 6.57101 9.64349 6.80045 9.45491C7.00357 9.28796 7.23762 9.1627 7.4892 9.0863C7.77337 9 8.08645 9 8.71259 9H9.4C9.96005 9 10.2401 9 10.454 8.89101C10.6422 8.79513 10.7951 8.64215 10.891 8.45399C11 8.24008 11 7.96005 11 7.4V3.1C11 2.53995 11 2.25992 10.891 2.04601C10.7951 1.85785 10.6422 1.70487 10.454 1.60899C10.2401 1.5 9.96005 1.5 9.4 1.5H9.2C8.07989 1.5 7.51984 1.5 7.09202 1.71799C6.71569 1.90973 6.40973 2.21569 6.21799 2.59202C6 3.01984 6 3.5799 6 4.7"
                              stroke="#667085"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1574_3453">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      ),
                      position: "start",
                      isOnly: false,
                    }}
                    size="sm"
                    label={feedback.name}
                  />
                )}
                <Badge
                  icon={{
                    icon: (
                      <svg
                        width="12"
                        height="11"
                        viewBox="0 0 12 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.25 7H3.5C2.80222 7 2.45333 7 2.16943 7.08612C1.53023 7.28002 1.03002 7.78023 0.83612 8.41943C0.75 8.70333 0.75 9.05222 0.75 9.75M7 3C7 4.24264 5.99264 5.25 4.75 5.25C3.50736 5.25 2.5 4.24264 2.5 3C2.5 1.75736 3.50736 0.75 4.75 0.75C5.99264 0.75 7 1.75736 7 3ZM5.25 9.75L6.80068 9.30695C6.87493 9.28573 6.91206 9.27512 6.94669 9.25922C6.97744 9.24511 7.00668 9.2279 7.03395 9.20788C7.06467 9.18533 7.09197 9.15803 7.14658 9.10342L10.375 5.87502C10.7202 5.52983 10.7202 4.97017 10.375 4.62499C10.0298 4.27981 9.47019 4.27982 9.12501 4.625L5.89658 7.85342C5.84197 7.90803 5.81467 7.93533 5.79212 7.96605C5.7721 7.99332 5.75489 8.02256 5.74078 8.05331C5.72487 8.08794 5.71427 8.12507 5.69305 8.19933L5.25 9.75Z"
                          stroke="#667085"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    ),
                    position: "start",
                    isOnly: false,
                  }}
                  size="sm"
                  label={feedback.creator_name}
                />
              </div>
            </div>
            <div className="student-feedback-hovering-option">
              <IconButton
                size="sm"
                hierarchy="secondaryGrey"
                destructive={true}
                onClick={() => {
                  setEditFeedbackMessage("");
                  setEditFeedback(false);
                  setCurrentAttachment(feedback);
                  setIsAttachmentChange(false);
                  setNewAttachedFiles([]);
                }}
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.835 0.835022L0.834961 10.835M0.834961 0.835022L10.835 10.835"
                    stroke="#B42318"
                    stroke-width="1.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </IconButton>
              <IconButton
                size="sm"
                hierarchy="secondaryGrey"
                destructive={false}
                className="student-feedback-save-btn"
                onClick={
                  editLoading
                    ? undefined
                    : () => {
                        editFeedbackFunction(feedback.id);
                        setEditFeedback(false);
                        // setIsAttachmentChange(false);
                      }
                }
                style={{
                  cursor: editLoading ? "not-allowed" : "pointer",
                  opacity: editLoading ? 0.5 : 1,
                }}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.6668 5L7.50016 14.1667L3.3335 10"
                    stroke="#12B76A"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </IconButton>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Feedback;
